import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import Head from 'next/head';
import nextI18nextConfig from '~/../next-i18next.config';
import { wrapper } from '~/store';
import defaultPage, {
  defaultPageServerSideContext,
} from '~/../hocs/defaultPage';
import AIPhotoContainer from '~/containers/AIPhotoPage';
import Layout from '~/containers/Layout';
import Config from '~/config';

class AIPhoto extends React.Component {
  render() {
    const { lng, t } = this.props;
    const siteURL = '/genface';
    const pageURL = `${siteURL}/genface`;
    return (
      <Layout>
        <Head>
          <title>{t('title_ai_photo_page')}</title>
          <meta
            id="meta-keywords"
            name="keywords"
            content={t('meta_keywords_ai_photo_page')}
          />
          <meta
            id="meta-description"
            name="description"
            content={t('meta_description_ai_photo_page')}
          />
          <meta property="og:title" content={t('title_ai_photo_page')} />
          <meta property="og:type" content="article" />
          <meta
            property="og:description"
            content={t('meta_description_ai_photo_page')}
          />
          <meta property="og:url" content={pageURL} />
          {!Config.isChina() && (
            <>
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:url" content={pageURL} />
              <meta name="twitter:title" content={t('title_ai_photo_page')} />
              <meta
                name="twitter:description"
                content={t('meta_description_ai_photo_page')}
              />
              <meta name="twitter:site" content={siteURL} />
            </>
          )}
        </Head>
        <AIPhotoContainer />
      </Layout>
    );
  }
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['common'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      clientIp,
      api,
      sessionId,
      ssoToken,
      query,
    } = await defaultPageServerSideContext({
      ...ctx,
      store,
    });

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
      },
    };
  },
);

export default defaultPage()(AIPhoto);
